export default __webpack_public_path__ + "static/media/Scandinavian-Pink.a0b4f9b8.jpg";